import { apiGet } from "../../../qv4/models/shared/apiClient";

function queryString(params = {}) {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") search.set(key, value);
  });
  return search.toString();
}

export async function fetchDispatcherOrders(params = {}) {
  const response = await apiGet(`/operations-v2/dispatcher/orders?${queryString(params)}`);
  if (!response.data?.success) throw new Error(response.data?.message || "Unable to load Operations orders.");
  return response.data.data || { rows: [], total: 0, pagination: null };
}

export async function fetchOperationsOrder(orderId) {
  const response = await apiGet(`/operations-v2/dispatcher/orders/${orderId}`);
  if (!response.data?.success) throw new Error(response.data?.message || "Unable to load the Operations order.");
  return response.data.data;
}
